<template>
	<div class="passwordForm">
		<button class="btn btn-primary btn-sm" ref="btnCheckTokenClient" @click="checkTokenClientLocal" v-show="false">Buscar Cliente</button>
		<div class="modal modal-sheet position-static d-block" tabindex="-1" role="dialog" id="modalSheet">
			<div class="modal-dialog" role="document">
				<div class="modal-content rounded-4 shadow" v-if="!verifierCodeSent">
					<div class="modal-header border-bottom-0">
						<h5 class="modal-title">{{ message[messageSelected].title }}</h5>
					</div>
					<div class="modal-body py-0">
						<p>{{ message[messageSelected].msg }}</p>
						<button class="btn btn-lg btn-sm btn-primary w-100 mx-0 mb-2" @click="sendVerificationCode" :disabled="searchingToken || sendingVerifiedCode">
							<span v-if="searchingToken">Verificando...</span>
							<span v-else>
								Envíar Código
							</span>
						</button>
						<router-link to="/access" class="btn btn-sm btn-lg btn-light w-100 mb-2">Volver</router-link>
					</div>
				</div>
				<div class="modal-content rounded-4 shadow" v-else>
					<div v-if="verifiedCode != 1">
						<div class="modal-header border-bottom-0">
							<h5 class="modal-title">Codigo Verificador</h5>
						</div>
						<div class="modal-body py-0">
							<p>Ingrese el código verificador que enviamos a {{ objectClient.email }}</p>
							<div class="text-center">
								<input type="text" class="form-control text-center" ref="inputCode" v-model="codeInfo.code" @keyup.enter="checkCodeVerification">
							</div>
							<br>
							<button class="btn btn-lg btn-sm btn-primary w-100 mx-0 mb-2" @click="checkCodeVerification" :disabled="disabledBtnVerifyCode">Verificar Código</button>
							<router-link to="/access" class="btn btn-sm btn-lg btn-light w-100 mb-2">Volver</router-link>
							<i class="text-warning" v-if="verifiedCode == 0">El código ingresado no corresponde</i>
						</div>
					</div>
					<div class="modal-content rounded-4 shadow" v-else>
						<div v-if="!passwordChanged">
							<div class="modal-header border-bottom-0">
								<h5 class="modal-title">{{ message[messageSelected].title }}</h5>
							</div>
							<div class="modal-body py-0">
								<div class="form-floating mb-3">
									<input type="password" class="form-control form-control-sm" id="floatingPassword" v-model="password">
									<label for="floatingPassword">Ingrese su nueva contraseña</label>
									<div id="passwordHelpBlock" class="form-text">
										Su contraseña debe tener 8 o más caracteres
										<i class="fa-solid fa-circle-exclamation text-warning" v-if="password.trim().length < 8"></i>
										<i class="fa-solid fa-check text-success" v-else></i>
									</div>
								</div>
								<div class="form-floating">
									<input type="password" class="form-control form-control-sm" id="floatingPasswordRepeat" v-model="passwordRepeat">
									<label for="floatingPasswordRepeat">Repita su nueva contraseña</label>
								</div>
								<br>
								<button class="btn btn-lg btn-sm btn-primary w-100 mx-0 mb-2" @click="savePasswordLocal" :disabled="disabledBtnSavePassword">Guardar</button>
								<router-link to="/access" class="btn btn-sm btn-lg btn-light w-100 mb-2">Volver</router-link>
							</div>
						</div>
						<div v-else>
							<div class="modal-header border-bottom-0">
								<h5 class="modal-title">Contraseña Cambiada</h5>
							</div>
							<div class="modal-body py-0">
								<p class="lead mb-4">Su contraseña a sido cambiada con exito. <span v-if="back != '' && back != null">Ahora será redirigido</span></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'
	import axiosSystem from '@/mixins/axiosSystem.js'
	import client from '@/mixins/client.js'

	export default {
		name: 'PasswordForm',
		mixins: [mixin, client, axiosAWN, axiosSystem],
		props: ['token', 'back'],
		data() {
			return {
				messageSelected: 0,
				message: [
					{title: 'Establecer contraseña', msg: 'Para mayor seguridad tiene que establecer una contraseña. Para eso tenemos que verificar tu correo'},
					{title: 'Cambio de contraseña', msg: 'Para continuar vamos a enviar un código a su correo'}
				],
				checkingVerifiedCode:false,
				verifierCodeSent: false,
				verifiedCode: -1,
				codeInfo: {
					type: '',
					tokenClient: this.token,
					code: ''
				},
				code: '',
				password: '',
				passwordRepeat: '',
				searchingToken: false,
				sendingVerifiedCode: false,
				passwordChanged: false,
				method: 'EMAIL'
			}
		},
		computed: {
			disabledBtnSavePassword() {
				if(this.password.trim().length < 8) {
					return true
				}
				if(this.password != this.passwordRepeat) {
					return true
				}
				return false
			},
			disabledBtnVerifyCode() {
				if(this.codeInfo.code.trim().length < 6) {
					return true
				}
				return this.checkingVerifiedCode
			}
		},
		methods: {
			checkCodeVerification() {
				if(this.codeInfo.code.trim().length == 6) {
					this.checkingVerifiedCode = true
					let url = this.getApiBackend + 'client/checkCodeVerification'
					this.axiosAWNasync('Espere mientras validamos su cuenta', 'POST', url, 'checkCodeVerificationResult', this.codeInfo)
				}
			},
			checkCodeVerificationResult(response) {
				if(response.data.success == true) {
					this.$awn.success('Cuenta chequeada')
					this.verifiedCode = 1
				} else {
					this.$awn.alert(response.data.message.msg)
				}
				this.checkingVerifiedCode = false
			},
			checkCodeVerificationResultError(error) {
				console.log(error)
				this.$awn.alert('Algo no funcionó como se esperaba')
				this.checkingVerifiedCode = false
			},
			checkTokenClientLocal() {
				this.searchingToken = true
				this.checkTokenClient(this.token)
			},
			checkTokenClientResultLocal(response) {
				if(response.data.success == true) {
					this.setObjectClient(response.data.data)
					this.messageSelected = (this.objectClient.password) ? 1 : 0
					this.searchingToken = false
				}
			},
			savePasswordLocal() {
				let url = this.getApiBackend + 'client/resetPassword'
				let data = {
					token: this.token,
					code: this.codeInfo.code,
					password: this.passwordRepeat,
				}
				this.axiosAWNasync('Estamos guardando su nueva contraseña', 'PUT', url, 'savePasswordResult', data)
			},
			savePasswordResult(response) {
				if(response.data.success == true) {
					this.$awn.success('Nueva clave guardada')
					this.passwordChanged = true
					if(this.back != '' && this.back != null) {
						setTimeout(() => {
							this.$router.push(this.back)
						}, 5000)
					}
				} else {
					this.$awn.alert('No se ha podido guardar su contraseña')
				}
			},
			sendVerificationCode(){
				this.sendingVerifiedCode = true

				let url = this.getApiBackend + 'client/sendCodeVerification'
				let data = {
						method: this.method,
						tokenClient: this.token,
						link: 'https://suscripcion.aceschile.cl/',
					}
				let destination = (this.method == 'SMS') ? this.objectClient.phone : this.objectClient.email
				console.log(url, data)
				this.axiosAWNasync('Enviando codigo al correo ' + destination, 'POST', url, 'sendVerificationCodeResult', data)
			},
			sendVerificationCodeResult(response) {
				if(response.data.success == true) {
					this.verifierCodeSent = true
					this.codeInfo.type = response.data.data.type
					this.$awn.success('El código fue enviado')
					setTimeout(() => {this.$refs.inputCode.focus()}, 100)
				} else {
					this.$awn.alert('Algo no funcionó bien')
					console.log(response)
				}
			},
		},
		mounted () {
		}
	}
</script>

<style scoped lang="scss">
</style>
